export default {
  /* Article */
  ARTICLE(state, data) {
    state.article        = data;
    state.articleLoading = false;
  },

  /* Comments */
  COMMENTS(state, data) {
    state.comments        = data;
    state.commentsLoading = false;
  },

  COMMENTS_WAITING(state, data) {
    state.commentsWaiting = data;
  },

  COMMENTS_STORE(state, data) {
    if (!(data.parent_id)) {
      return state.comments.push(data);
    }

    for (const comment of state.comments) {
      if (comment.id === data.parent_id) {
        comment.children ??= [];
        return comment.children.push(data);
      }
    }
  }
}
